import React, { Component } from 'react';
import './add-school.scss';
import Dropdown from '../../common/dropdown-v2/dropdown';
import DropdownV3 from '../../common/dropdown-v3/dropdown';
import { ImageConstants, Constants } from '../../../constants/constants';
import { getImageSource } from '../../../utility/image-source'
import PillButtonSelect from '../../common/pill-button-select/pill-button-select';
import MasterDataAPI from '../../../apis/master-data'
import CouponApi from '../../../apis/coupons'
import CommonApi from '../../../apis/common'
import SchoolApi from '../../../apis/school'
import ToasterComponent from '../../common/cw-toaster-component/cw-toaster-component';

import CommonUtils from '../../../utility/common-utilities';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

class AddSchool extends Component {

    state = {
        loading: true,
        boards: [],
        classes: [],
        type: [],
        medium: [],
        feeStructure: [],
        plan: "",
        boardsList: [],
        typesList: Constants.SCHOOL_ONBOARD.TYPES_LIST,
        mediumList: Constants.SCHOOL_ONBOARD.MEDIUM_LIST,
        feeStructureList: Constants.SCHOOL_ONBOARD.FEE_STRUCTURE_LIST,
        planList: Constants.SCHOOL_ONBOARD.PLAN_LIST,

        classDropdownItems: [],
        subscriptionPlansDropdown: [],
        couponDropdownItems: [],
        contactList: [],
        hashedCountryCode: {},
        couponDetail: {},
        subscription: {}
    };

    componentDidMount() {
        this.getSchool()
        this.getCountryCodes();
        this.getBoardDetails()
        this.getClassDetails()
    }

    getSchool(payload = {}) {
        SchoolApi.getSchool(payload)
            .then(schools => {
                let result = schools?.response[0]
                this.setDefaultValue(result)
                this.getBoardDetails();
                if (result?.coupon) {
                    this.getCouponDetail(result.coupon?.id)
                } else {
                    this.getSubscription(result.subscription.id)
                }
            }).catch(err => {
            })
    }


    getCouponDetail(couponId) {
        let payload = { couponId }
        CouponApi.getCouponDetail(payload)
            .then(response => {
                this.setState({ couponDetail: response, subscription: response.subscription })
            }).catch(err => {
            })
    }

    getSubscription(subscriptionId) {
        let payload = { _id: subscriptionId }
        CouponApi.getSubcriptions(payload)
            .then(response => {
                this.setState({ subscription: response[0] })
            }).catch(err => {
            })
    }

    getBoardDetails() {
        let payload = { limit: 100, display: "SHOW" };
        MasterDataAPI.getBoard(payload)
            .then(boardData => {

                let items = [];
                for (let i = 0; i < boardData.response.length; i++) {
                    items.push({
                        title: boardData.response[i].title,
                        value: boardData.response[i].title,
                    })
                }

                this.setState({ boardsList: items })
            }).catch(err => {
                this.setState({
                    boardDropdownLoading: false
                });
            })
    }


    getClassDetails() {

        let payload = { limit: 100 };

        MasterDataAPI.getClass(payload)
            .then((classData) => {

                let items = [];
                for (let i = 0; i < classData.response.length; i++) {
                    if (classData.response[i].title == "Class 5") continue
                    items.push({
                        title: classData.response[i].title,
                        value: classData.response[i].title
                    })
                }

                this.setState({
                    classDropdownLoading: false,
                    classDropdownItems: items
                })
            }).catch(err => {
                this.setState({
                    classDropdownLoading: false
                })
            })
    }

    setDefaultValue(school = {}) {
        let adminName = school.adminName
        let schoolName = school.name
        let city = school?.address?.city
        let branch = school.address?.branch
        let email = school.email
        let mobileNumber = school.mobileNumber
        let selectedCountryCode = school.countryCode
        let plan = school.plan?.type
        let coupon = school?.coupon?.id

        let boards = school.board?.map(item => item.name)
        let type = school.type?.map(item => item.name)
        let medium = school.medium?.map(item => item.name)
        let feeStructure = school.feeStructure?.map(item => item.name)

        let classes = [], selectedClassesDropdown = []

        for (let i = 0; i < school.classes.length; i++) {
            let className = school.classes[i].name
            classes.push(className)
            selectedClassesDropdown.push({ title: className, value: className })
        }

        let subscriptionPlan = "", subscriptionPlanDropdown = [], couponDropdownItems = []

        if (plan == Constants.PLAN_TYPES.B2B) {
            subscriptionPlan = school.product[0]?.id
            subscriptionPlanDropdown.push({ title: school.product[0]?.name, value: school.product[0]?.id })
        }

        if (plan == Constants.PLAN_TYPES.B2B2C) {
            couponDropdownItems.push({ title: school?.coupon?.couponCode, value: school?.coupon?.id })
        }

        this.setState({
            schoolName,
            coupon,
            subscriptionPlan,
            mobileNumber,
            plan,
            medium,
            feeStructure,
            selectedCountryCode,
            type,
            email,
            city,
            branch,
            boards,
            classes,
            adminName,
            subscriptionPlanDropdown,
            selectedClassesDropdown,
            loading: false,
            isEdit: true,
            couponDropdownItems
        })


    }

    getCountryCodes(payload) {

        CommonApi.getCountryCodeList(payload).then(response => {
            let data = response.response
            if (data.length) {
                this.setState({ countryList: data })
                let countryCodeDropdown = this.buildCountryCodeDropdown(data)
                this.setState({ countryCodeDropdown: countryCodeDropdown })

            }
        }).catch(err => {
        })

    }


    buildCountryCodeDropdown(list = []) {
        let countryCodeDropdown = [];
        let countryCodeHash = {}
        for (let i = 0; i < list.length; i++) {
            let item = list[i]

            if (!countryCodeHash[item.dialCode]) {
                countryCodeHash[item.dialCode] = item
                countryCodeDropdown.push({ title: `${item.name} (${item.dialCode})`, value: item.dialCode })
            }
        }
        this.setState({ hashedCountryCode: countryCodeHash })
        return countryCodeDropdown
    }


    onSelectCountryCode(option) {
        this.setState({ selectedCountryCode: option?.value })
    }

    onSelectSubscriptionPlan(option) {
        this.setState({ subscriptionPlan: option?.value })
    }

    onSelectCoupon(option) {
        this.setState({ coupon: option?.value })
    }

    onCountryCodeSearch(value, index) {
        if (value.length > 2 || !value) {
            this.countryCodeIndex = index
            this.getCountryCodes({ name: `/${value}`, })
        }
    }

    onSelectClass = (option) => {
        let classes = option.map(item => item.value)
        this.setState({ classes })
    }

    onSelectMultiSubscriptionPlan = (option) => {
        let subscriptionPlan = option.map(item => item.value)
        this.setState({ subscriptionPlan })
    }


    validateEmail(value) {
        if (value) {
            let isValid = CommonUtils.validateEmail(value);
            if (!isValid) {
                this.setState({ isInvalidEmail: true });
                return false
            }
            else {
                this.setState({ isInvalidEmail: false })
                return true
            }
        } else {
            this.setState({ isInvalidEmail: true });
        }
    }

    onChangeHandler = (event, key) => {

        // this.setState({ })

        if (key == "mobileNumber") {

            if (!event.target.value) {
                this.setState({ mobileNumber: event.target.value })
                return
            }

            if (!CommonUtils.isAllowMobileNumber(event.target.value)) {
                let stateValue = this.state.mobileNumber
                this.setState({ mobileNumber: "" }, () => {
                    this.setState({ mobileNumber: stateValue })
                })
                return
            }
        }

        this.setState({ [key]: event.target.value })
    }

    onSelectPillButton = (value, key) => {
        this.setState({ [key]: value })
    }

    onCLickAdd = () => {

        this.setState({ isSubmit: true })
        let payload = {
            type: this.state.type.map(item => ({ name: item })),
            medium: this.state.medium.map(item => ({ name: item })),
            board: this.state.boards.map(board => ({ name: board })),
            classes: this.state.classes.map(className => ({ name: className })).sort((a, b) => a.name > b.name ? 1 : -1),
            feeStructure: this.state.feeStructure.map(item => ({ name: item })),
        }

        if (!this.validatePayload(payload)) return

        SchoolApi.updateSchool(payload).then(response => {
            this.setState({
                formEnabled: false,
                isSubmit: false
            })
            this.props.onSave && this.props.onSave()
        }).catch(err => {
            this.showToaster("error", 'Oops something went wrong');
        })
    }

    validatePayload(payload) {
        if (!payload.type?.length) return false
        if (!payload?.medium?.length) return false
        if (!payload.board?.length) return false
        if (!payload.classes?.length) return false
        if (!payload.feeStructure?.length) return false
        return true
    }

    onClickAddContact() {
        this.setState({ isOpenAddContact: true })
    }

    closeContactModal = () => {
        this.setState({ isOpenAddContact: false })
    }

    getTypesName(types = []) {
        let name = types.map(type => type.type)
        return name.join(', ')
    }

    onContactSave = (payload) => {
        let contacts = this.state.contactList
        this.setState({ contactList: [...contacts, payload] })
        this.setState({ isOpenAddContact: false })
    }

    onClickClearContact(index) {
        let contactList = this.state.contactList
        contactList.splice(index, 1)
        this.setState({ contactList })
    }

    showToaster(type, message) {
        this.setState({
            showToaster: true,
            toasterMessage: message,
            toasterType: type
        }, () => {
            setTimeout(() => { this.hideToaster() }, 3000);
        });
    }

    hideToaster() {
        this.setState({
            showToaster: false
        });
    }

    renderProductDropdown() {
        return (
            <div className="row coupon p-2 mx-1">
                <div className="col ml-2 subscription border-right">
                    <b>{`${this.state.subscription?.currency?.symbol} `} </b>
                    <span className="strike">{this.state.subscription?.basePrice}</span>
                    <span>&nbsp;{`  ${this.state.subscription?.discountedPrice}`} </span>
                    <span> {this.getPlanValidity(this.state.subscription?.numberOfDays)}</span>
                </div>
                {
                    this.state.couponDetail ?
                        <div className="col my-auto">
                            <span className="coupon-code">DISCOUNT CODE : </span> {this.state.couponDetail?.couponCode}
                        </div>
                        : ""
                }
            </div>)
    }

    getPlanValidity(value) {
        if (value == 7) {
            return "/ Week"
        }
        if (value == 30) {
            return "/ Month"
        }
        if (value == 365) {
            return "/ Year"
        }
        return "/ Year"
    }

    enableForm = _ => {
        this.setState({
            formEnabled: true
        })
    }

    renderSchoolCard() {
        const {formEnabled} = this.state
        return (
            <div className="sign-up center-box">
                <div className=''>
                    <div className=''>
                        <div className='row'>
                            <div className='col text-right'>
                                {!formEnabled && 
                                    <button className='cw-btn-primary cw-btn-md form-edit cursor-pointer' onClick={_=> this.enableForm()}>
                                        <img src={getImageSource(ImageConstants.PENCIL_ICON)} className='pencil-icn mr-1' /> Edit
                                    </button>
                                }
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col'>
                                <label className='cw-input-label'>SCHOOL ADMIN NAME <span className='star'>*</span></label>
                                <input className={`cw-input not-editable ${this.state.isSubmit && !this.state.adminName?.trim() ? "invalid" : ""}`} placeholder='Enter Admin Name'
                                    value={this.state.adminName}
                                    onChange={(e) => this.onChangeHandler(e, 'adminName')} disabled />
                                {/* {this.state.isSubmit && !this.state.adminName ? <span className='invalid-text'>Please enter admin name</span> : ''} */}
                            </div>
                        </div>

                        <div className='row bw-spaces-input'>
                            <div className='col'>
                                <label className='cw-input-label'>SCHOOL NAME <span className='star'>*</span></label>
                                <input className={`cw-input not-editable ${this.state.isSubmit && !this.state.schoolName?.trim() ? "invalid" : ""}`} placeholder='Enter School Name'
                                    value={this.state.schoolName}
                                    onChange={(e) => this.onChangeHandler(e, 'schoolName')} disabled />
                                {/* {this.state.isSubmit && !this.state.schoolName ? <span className='invalid-text'>Please enter school name</span> : ''} */}
                            </div>
                        </div>

                        <div className='row bw-spaces-input'>
                            <div className='col'>
                                <label className='cw-input-label'>CITY <span className='star'>*</span></label>
                                <input className={`cw-input not-editable  ${this.state.isSubmit && !this.state.city?.trim() ? "invalid" : ""}`} placeholder='Enter City'
                                    value={this.state.city}
                                    onChange={(e) => this.onChangeHandler(e, 'city')} disabled />
                                {/* {this.state.isSubmit && !this.state.city ? <span className='invalid-text'>Please enter city</span> : ''} */}
                            </div>
                            <div className='col'>
                                <label className='cw-input-label'>BRANCH <span className='star'>*</span></label>
                                <input className={`cw-input not-editable  ${this.state.isSubmit && !this.state.branch?.trim() ? "invalid" : ""}`} placeholder='Enter Branch'
                                    value={this.state.branch}
                                    onChange={(e) => this.onChangeHandler(e, 'branch')} disabled />
                                {/* {this.state.isSubmit && !this.state.branch ? <span className='invalid-text'>Please enter branch</span> : ''} */}
                            </div>
                        </div>

                        <div className='bw-spaces-input'>
                            <div className='cw-input-label'>PHONE NUMBER <span className='star'>*</span></div>
                            <div className='row'>
                                <div className='col-4 pr-0'>
                                    <input className={`cw-input not-editable `} value={this.state.selectedCountryCode} disabled />
                                </div>
                                <div className='col'>
                                    <input className={`cw-input not-editable  ${(this.state.isSubmit && !this.state.mobileNumber) || this.state.isInvalidMobile ? "invalid" : ""}`} placeholder='Enter Mobile Number'
                                        value={this.state.mobileNumber}
                                        onChange={(e) => this.onChangeHandler(e, 'mobileNumber')} disabled />
                                    {/* {this.state.isSubmit && !this.state.mobileNumber ? <span className='invalid-text'>Please enter mobile number</span> : ''} */}
                                </div>
                            </div>
                        </div>

                        <div className='row bw-spaces-input'>
                            <div className='col'>

                                <label className='cw-input-label'>EMAIL ID <span className='star'>*</span></label>
                                <input className={`cw-input  not-editable  ${this.state.isInvalidEmail ? "invalid" : ""}`}
                                    placeholder='Enter Your Email Id'
                                    onChange={(e) => this.onChangeHandler(e, 'email')}
                                    onBlur={(event) => this.validateEmail(event.target.value)}
                                    value={this.state.email} disabled />

                                {/* {this.state.isInvalidEmail ? <span className='invalid-text'>Please enter valid email id</span> : ''} */}
                            </div>
                        </div>

                        <div className='row bw-spaces-input'>
                            <div className='col'>
                                <label className='cw-input-label'>BOARD <span className='star'>*</span></label>
                                <PillButtonSelect
                                    isMultiple
                                    onSelect={(value) => this.onSelectPillButton(value, "boards")}
                                    options={this.state.boardsList}
                                    value={this.state.boards}
                                    invalid={this.state.isSubmit && !this.state.boards.length}
                                    disabled={!formEnabled}
                                />
                            </div>
                        </div>

                        <div className='row bw-spaces-input'>
                            <div className='col-10'>
                                <label className='cw-input-label'>CLASS <span className='star'>*</span></label>
                                {
                                    this.state.classDropdownItems?.length ?
                                        <div >
                                            <Dropdown
                                                multiSelect
                                                placeholder='Select Class'
                                                options={this.state.classDropdownItems}
                                                onSelect={(option) => this.onSelectClass(option)}
                                                text={"title"}
                                                style={{ background: "#F6F7F5" }}
                                                value={this.state.classes}
                                                invalid={this.state.isSubmit && !this.state.classes.length}
                                                disabled={!formEnabled}
                                            />
                                        </div> : ""}
                                {/* {this.state.isSubmit && !this.state.classes.length ? <span className='invalid-text'>Please select class</span> : ''} */}
                            </div>
                        </div>

                        <div className='row bw-spaces-input'>
                            <div className='col'>
                                <label className='cw-input-label'>TYPE <span className='star'>*</span></label>
                                <PillButtonSelect
                                    isMultiple
                                    onSelect={(value) => this.onSelectPillButton(value, "type")}
                                    options={this.state.typesList}
                                    value={this.state.type}
                                    width="150px"
                                    invalid={this.state.isSubmit && !this.state.type?.length}
                                    disabled={!formEnabled}
                                />
                            </div>
                        </div>

                        <div className='row bw-spaces-input'>
                            <div className='col'>
                                <label className='cw-input-label'>MEDIUM <span className='star'>*</span></label>
                                <PillButtonSelect
                                    isMultiple
                                    onSelect={(value) => this.onSelectPillButton(value, "medium")}
                                    options={this.state.mediumList}
                                    value={this.state.medium}
                                    width="150px"
                                    invalid={this.state.isSubmit && !this.state.medium?.length}
                                    disabled={!formEnabled}
                                />
                            </div>
                        </div>

                        <div className='row bw-spaces-input'>
                            <div className='col'>
                                <label className='cw-input-label'>FEE STRUCTURE <span className='star'>*</span></label>
                                <PillButtonSelect
                                    isMultiple
                                    onSelect={(value) => this.onSelectPillButton(value, "feeStructure")}
                                    options={this.state.feeStructureList}
                                    value={this.state.feeStructure}
                                    width="150px"
                                    invalid={this.state.isSubmit && !this.state.feeStructure?.length}
                                    disabled={!formEnabled}
                                />
                            </div>
                        </div>
                        {/* 
                        <div className='row bw-spaces-input'>
                            <div className='col'>
                                <label className='cw-input-label'>PLAN <span className='star'>*</span></label>
                                <PillButtonSelect
                                    onSelect={(value) => this.onSelectPillButton(value, "plan")}
                                    options={this.state.planList}
                                    value={this.state.plan}
                                    width="150px"
                                    invalid={this.state.isSubmit && !this.state.plan}
                                    disabled={true}
                                />
                            </div>
                        </div> */}

                        {/* <div className='row bw-spaces-input'>
                            <div className='col-10'>
                                <label className='cw-input-label'>PRICING PLAN </label>
                                {
                                    this.state.plan ? this.renderProductDropdown() : ""
                                }
                            </div>
                        </div> */}

                        <div className="pt-2">
                            <span className="note">
                                Students of your school will be eligible for a {this.state.couponDetail?.discount?.value}{this.state.couponDetail?.discount?.type == "PERCENTAGE" ? "%" : " INR"} discount on the MRP if they wish to subscribe to Countingwell Premium Learning Plans. However, the homework access will remain free for all students
                            </span>
                        </div>
                    </div>

                    <div className='continue-button text-center' onClick={() => this.onCLickAdd()}>
                        <div className='footer-text cursor-pointer'>{!this.state.isEdit ? "ADD" : "CONFIRM"}</div>
                    </div>

                    <div className="pt-4">
                        <span className="note">NOTE: To update the grayed out fields above reach out to countingwell admin at <span className="text-blue">support@countingwell.com</span></span>
                    </div>
                </div>
            </div >
        )
    }

    render() {
        return (
            <>


                <div className="add-school">
                    {
                        !this.props.disableBack ?
                            <div className="pb-4"><FontAwesomeIcon className="cursor-pointer back-icon text-left" icon={faArrowLeft} onClick={this.props.back} />
                            </div> : ""
                    }
                    {
                        !this.state.loading ?
                            <div className='row'>
                                <div className='col-12 '>
                                    {
                                        !this.props.disableHeader ? <div className="">
                                            <strong className="header-text">{!this.state.isEdit ? "Add New School" : this.props.headerTitle || "Edit School"}</strong>
                                        </div> : ""
                                    }
                                    <div>
                                        {this.renderSchoolCard()}
                                    </div>
                                </div>
                                {/* <div className='col py-4'>
                                    <img src={getImageSource(ImageConstants.PROFILE_VECTOR)} className='profile-vector-img' />
                                </div> */}
                            </div>
                            :
                            ""
                    }
                </div>

                {/* <div className="text-right px-0">
                    <img src={getImageSource(ImageConstants.GRAPHIC2)} className='image-buttom' />
                </div> */}
                {this.state.showToaster ? <ToasterComponent message={this.state.toasterMessage} type={this.state.toasterType} /> : ""}
            </>
        )
    }
}

export default AddSchool;